import { CDCEnrichmentMode } from './form-data';
import { Database } from 'entities/database';

export const getHasCDCEnrichmentMode = (database: Database) => {
  return [CDCEnrichmentMode.DIFF, CDCEnrichmentMode.FULL].includes(
    database.DesiredSettings?.CDCEnrichmentMode
  );
};
